"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const keydown_key_1 = __importDefault(require("keydown-key"));
const keyDownHandlerProxy = (keyDownEvent, actions) => {
    const { onBackspace, onTab, onEnter, onEscape } = actions;
    const { key: eventKey } = (0, keydown_key_1.default)(keyDownEvent.nativeEvent);
    switch (eventKey) {
        case 'Backspace':
            onBackspace === null || onBackspace === void 0 ? void 0 : onBackspace(keyDownEvent);
            break;
        case 'Tab':
            onTab === null || onTab === void 0 ? void 0 : onTab(keyDownEvent);
            break;
        case 'Enter':
            onEnter === null || onEnter === void 0 ? void 0 : onEnter(keyDownEvent);
            break;
        case 'Escape':
            onEscape === null || onEscape === void 0 ? void 0 : onEscape(keyDownEvent);
            break;
        default:
    }
};
exports.default = keyDownHandlerProxy;
